import AnimatedValue from './AnimatedValue';

export default AnimatedValue;
